const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M42.822 11.676a2.256 2.256 0 013.22 0c.89.902.89 2.364 0 3.265l-25.02 28.542a3.76 3.76 0 01-5.368 0L2.667 28.373a2.331 2.331 0 010-3.265 2.256 2.256 0 013.22 0l12.451 14.566 24.484-27.998z"
            fill="currentColor" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=check.es.juGVHa96.js.map
